import { render, staticRenderFns } from "./whoAreWe.vue?vue&type=template&id=6209bfc6&scoped=true"
import script from "./whoAreWe.vue?vue&type=script&lang=js"
export * from "./whoAreWe.vue?vue&type=script&lang=js"
import style0 from "./whoAreWe.vue?vue&type=style&index=0&id=6209bfc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6209bfc6",
  null
  
)

export default component.exports